import { InboxIcon } from '@hugeicons/core-free-icons';
import { createIcon } from '../icon';

export const Inbox = /* @__PURE__ */ createIcon(InboxIcon, 'Inbox');
